var PeopleMedia = PeopleMedia || {};
var PeopleMedia = PeopleMedia || {};
PeopleMedia.CP = PeopleMedia.CP || {};
PeopleMedia.CP.Registration = (function ($jq) {
    "use strict";

    var Oid = "PeopleMedia.CP.Registration";

    var _emailGUID = "";
    var _registrationButtonFieldname = "btnRegister";
    var _onRegistrationSuccess = null;
    var _onRegistrationFailure = null;
    var _registrationPanelId = "divRegistration";
    var _usernameFieldname = "txtUsername";
    var _passwordFieldname = "txtPassword";
    var _emailAddressFieldname = "txtEmailAddress";
    var _emailAddressConfirmationFieldname = "txtEmailAddressConfirmation";
    var _countryCodeFieldname = "ddlCountry";
    var _postalCodeFieldname = "txtPostalCode";
    var _postalCodeDivFieldname = "divPostalCode";
    var _genderFieldname = "ddlGender";
    var _genderSeekFieldname = "ddlGenderSeek";
    var _genderCombinedFieldname = "ddlGenderCombined";
    var _birthDateCombinedFieldname = "txtBirthDate";
    var _birthMonthFieldname = "ddlBirthMonth";
    var _birthDayFieldname = "ddlBirthDay";
    var _birthYearFieldname = "ddlBirthYear";
    var _termsAndConditionsClassname = "chkTermsAndConditions";
    var _surveyAnswerFieldname = "ddlSurveyAnswer";
    var _registrationData = null;
    var _panelCount = 1;
    var _questions = [];
    var _currentPanelNumber = 1;
    var _onQuestionDisplay = null;
    var _originalEmailAddress = "";
    var _registrationFailed = false;
    var _countries = [
        { code: "US", name: "United States" },
        { code: "CA", name: "Canada" }
    ];

    var registrationInProgress = false;
    var _arkoseResponseValid = false;

    var EmailGUID = function(emailGUID) {
        if (arguments.length > 0) {
            _emailGUID = emailGUID;
        } else {
            return _emailGUID;
        }
    };

    var RegistrationButtonFieldname = function(name) {
        if (arguments.length > 0) {
            _registrationButtonFieldname = name;
        } else {
            return _registrationButtonFieldname;
        }
    };

    var OnRegistrationSuccess = function(onRegistrationSuccess) {
        if (arguments.length > 0) {
            _onRegistrationSuccess = onRegistrationSuccess;
        } else {
            return _onRegistrationSuccess;
        }
    };

    var OnRegistrationFailure = function(onRegistrationFailure) {
        if (arguments.length > 0) {
            _onRegistrationFailure = onRegistrationFailure;
        } else {
            return _onRegistrationFailure;
        }
    };

    var RegistrationPanelId = function(registrationPanelId) {
        if (arguments.length > 0) {
            _registrationPanelId = registrationPanelId;
        } else {
            return _registrationPanelId;
        }
    };

    var RegistrationPanel = function() {
        return $jq("#" + RegistrationPanelId());
    };

    var UsernameFieldname = function(name) {
        if (arguments.length > 0) {
            _usernameFieldname = name;
        } else {
            return _usernameFieldname;
        }
    };

    var Username = function(username) {
        var $username = $jq("#" + UsernameFieldname());
        if ($username.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $username.val(username);
        }
        return $username.val();
    };

    var PasswordFieldname = function(name) {
        if (arguments.length > 0) {
            _passwordFieldname = name;
        } else {
            return _passwordFieldname;
        }
    };

    var Password = function(password) {
        var $password = $jq("#" + PasswordFieldname());
        if ($password.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $password.val(password);
        }
        return $password.val();
    };

    var EmailAddressFieldname = function(name) {
        if (arguments.length > 0) {
            _emailAddressFieldname = name;
        } else {
            return _emailAddressFieldname;
        }
    };

    var EmailAddress = function(emailAddress) {
        var $email = $jq("#" + EmailAddressFieldname());
        if ($email.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $email.val(emailAddress);
        }
        return $email.val();
    };

    var OriginalEmailAddress = function() {
        if (arguments.length > 0) {
            _originalEmailAddress = name;
        } else {
            return _originalEmailAddress;
        }
    };

    var EmailAddressConfirmationFieldname = function() {
        if (arguments.length > 0) {
            _emailAddressConfirmationFieldname = name;
        } else {
            return _emailAddressConfirmationFieldname;
        }
    };

    var EmailAddressConfirmation = function(emailAddressConfirmation) {
        var $emailConfirm = $jq("#" + EmailAddressConfirmationFieldname());
        if ($emailConfirm.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $emailConfirm.val(emailAddressConfirmation);
        }
        return $emailConfirm.val();
    };

    var HasEmailAddressConfirmationField = function() {
        var field = $jq("#" + EmailAddressConfirmationFieldname());
        return (typeof (field) !== 'undefined' && field !== null && field.length > 0);
    };

    var CountryCodeFieldname = function(name) {
        if (arguments.length > 0) {
            _countryCodeFieldname = name;
        } else {
            return _countryCodeFieldname;
        }
    };

    var CountryCode = function(countryCode) {
        var $countryCode = $jq("#" + CountryCodeFieldname());
        if ($countryCode.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $countryCode.val(countryCode);
        }
        return $countryCode.val();
    };

    var PostalCodeFieldname = function(name) {
        if (arguments.length > 0) {
            _postalCodeFieldname = name;
        } else {
            return _postalCodeFieldname;
        }
    };

    var PostalCode = function(postalCode) {
        var $postalCode = $jq("#" + PostalCodeFieldname());
        if ($postalCode.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $postalCode.val(postalCode);
        }
        return $postalCode.val();
    };

    var PostalCodeDivFieldname = function(name) {
        if (arguments.length > 0) {
            _postalCodeDivFieldname = name;
        } else {
            return _postalCodeDivFieldname;
        }
    };

    var GenderFieldname = function(name) {
        if (arguments.length > 0) {
            _genderFieldname = name;
        } else {
            return _genderFieldname;
        }
    };

    var Gender = function(gender) {
        var $gender = $jq("#" + GenderFieldname());
        if ($gender.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $gender.val(gender);
        }
        return $gender.val();
    };

    var GenderSeekFieldname = function(name) {
        if (arguments.length > 0) {
            _genderSeekFieldname = name;
        } else {
            return _genderSeekFieldname;
        }
    };

    var GenderSeek = function(genderSeek) {
        var $genderSeek = $jq("#" + GenderSeekFieldname());
        if ($genderSeek.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $genderSeek.val(genderSeek);
        }
        return $genderSeek.val();
    };

    var GenderCombinedFieldname = function(name) {
        if (arguments.length > 0) {
            _genderCombinedFieldname = name;
        } else {
            return _genderCombinedFieldname;
        }
    };

    var HasGenderCombinedField = function() {
        var field = $jq("#" + GenderCombinedFieldname());
        return (typeof (field) !== 'undefined' && field !== null && field.length > 0);
    };

    var GenderCombined = function(genderCombined) {
        var $genderCombined = $jq("#" + GenderCombinedFieldname());
        if ($genderCombined.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $genderCombined.val(genderCombined);
        }
        return $genderCombined.val();
    };

    var GenderCombinedSelf = function() {
        if (typeof(GenderCombined()) !== 'undefined' &&  GenderCombined() !== null && GenderCombined().length === 2) {
            return GenderCombined().substr(0, 1);
        }
        return "";
    };

    var GenderCombinedSeeking = function() {
        if (typeof (GenderCombined()) !== 'undefined' && GenderCombined() !== null && GenderCombined().length === 2) {
            return GenderCombined().substr(1, 1);
        }
        return "";
    };

    var BirthDateCombinedFieldname = function(name) {
        if (arguments.length > 0) {
            _birthDateCombinedFieldname = name;
        } else {
            return _birthDateCombinedFieldname;
        }
    };

    var HasBirthDateCombinedField = function() {
        var field = $jq("#" + BirthDateCombinedFieldname());
        return (typeof (field) !== 'undefined' && field !== null && field.length > 0);
    };

    var BirthDateCombined = function(birthdateCombined) {
        var $birthdayCombined = $jq("#" + BirthDateCombinedFieldname());
        if ($birthdayCombined.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $birthdayCombined.val(birthdateCombined);
        }
        return $birthdayCombined.val();
    };

    var BirthMonthFieldname = function(name) {
        if (arguments.length > 0) {
            _birthMonthFieldname = name;
        } else {
            return _birthMonthFieldname;
        }
    };

    var BirthMonth = function(birthMonth) {
        var $birthMonth = $jq("#" + BirthMonthFieldname());
        if ($birthMonth.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $birthMonth.val(birthMonth);
        }
        return $birthMonth.val();
    };

    var BirthDayFieldname = function(name) {
        if (arguments.length > 0) {
            _birthDayFieldname = name;
        } else {
            return _birthDayFieldname;
        }
    };

    var BirthDay = function(birthDay) {
        var $birthDay = $jq("#" + BirthDayFieldname());
        if ($birthDay.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $birthDay.val(birthDay);
        }
        return $birthDay.val();
    };

    var BirthYearFieldname = function(name) {
        if (arguments.length > 0) {
            _birthYearFieldname = name;
        } else {
            return _birthYearFieldname;
        }
    };

    var BirthYear = function(birthYear) {
        var $birthYear = $jq("#" + BirthYearFieldname());
        if ($birthYear.length === 0) {
            return null;
        }
        if (arguments.length > 0) {
            $birthYear.val(birthYear);
        }
        return $birthYear.val();
    };

    var BirthDate = function(birthDate) {
        var hasBirthDateCombinedField = HasBirthDateCombinedField();
        if (arguments.length > 0) {
            if (hasBirthDateCombinedField) {
                return BirthDateCombined(birthDate);
            }
            var bd = PeopleMedia.CP.Utilities.parseDateString(birthDate);
            if (bd) {
                BirthMonth(bd.dtMonth);
                BirthDay(bd.dtDay);
                BirthYear(bd.dtYear);
                return BirthMonth() + '/' + BirthDay() + '/' + BirthYear();
            }
        }
        if (hasBirthDateCombinedField) {
            return BirthDateCombined();
        }
        return BirthMonth() + '/' + BirthDay() + '/' + BirthYear();
    };

    var SurveyAnswerFieldName = function(name) {
        if (arguments.length > 0) {
            _surveyAnswerFieldname = name;
        } else {
            return _surveyAnswerFieldname;
        }
    };

    var TermsAndConditionsClassname = function(name) {
        if (arguments.length > 0) {
            _termsAndConditionsClassname = name;
        } else {
            return _termsAndConditionsClassname;
        }
    };

    var TermsAndConditions = function () {
        return $jq("." + TermsAndConditionsClassname()).is(":checked");
    };

    var RegistrationData = function() {
        return _registrationData;
    };

    var Questions = function() {
        return _questions;
    };

    var PanelCount = function(panelCount) {
        if (arguments.length > 0) {
            _panelCount = panelCount;
        } else {
            return _panelCount;
        }
    };

    var CurrentPanelNumber = function(currentPanelNumber) {
        if (arguments.length > 0) {
            _currentPanelNumber = currentPanelNumber;
        } else {
            return _currentPanelNumber;
        }
    };

    var OnQuestionDisplay = function(onQuestionDisplay) {
        if (arguments.length > 0) {
            _onQuestionDisplay = onQuestionDisplay;
        } else {
            return _onQuestionDisplay;
        }
    };

    var RegistrationFailed = function(registrationFailed) {
        if (arguments.length > 0) {
            _registrationFailed = registrationFailed;
        } else {
            return _registrationFailed;
        }
    };

    var loadCountryDDL_Div = function (ddlId, $container) {
        try {
            var templateItemName = ddlId + "ItemTemplate";

            var template = $jq("<div>").append($jq("#" + ddlId + "ItemTemplate").clone());
            template.children().css("display", "");
            var templateHtml = template.html();

            var html = "";
            $jq.each(_countries,
                function (idx, country) {
                    html += templateHtml.replace("##COUNTRYNAME##", country.name)
                        .replace("##COUNTRYCODE##", country.code)
                        .replace(templateItemName, ddlId + "Item" + country.code);
                });
            $container.html(html);
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "loadCountryDDL_Div" });
        }
    };

    var loadCountryDDL = function (ddlId) {
        try {
            var $ddlContainer = $jq("#" + ddlId + "Container");
            if ($ddlContainer.length > 0 && $ddlContainer.is("div")) {
                loadCountryDDL_Div(ddlId, $ddlContainer);
            } else {
                PeopleMedia.CP.loadDDL(ddlId, _countries, "code", "name");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "loadCountryDDL" });
            PeopleMedia.CP.loadDDL(ddlId, _countries, "code", "name");
        }
    };

    var initialize = function(currentQueryString) {
        try {
            // SiteId(PeopleMedia.CP.SiteID());
            var keyValues = PeopleMedia.Net.getQueryString(currentQueryString);
            var emailGUID = PeopleMedia.Net.getQueryStringValue(keyValues, "EmailGUID");
            if (typeof (emailGUID) !== 'undefined' && emailGUID !== null && emailGUID.length === 36) {
                EmailGUID(emailGUID);
            }

            var regButtonName = RegistrationButtonFieldname();
            if (typeof (regButtonName) !== 'undefined' && regButtonName !== null && $jq('#' + regButtonName)) {

                if (PeopleMedia.Configuration.isArkoseCaptchaRequired === true) {
                    PeopleMedia.CP.ArkoseCaptcha.initialize({
                        captchaLocation: "CreateMember",
                        $form: $jq("#lpsrvt"),
                        selector: '#' + regButtonName,
                        onValidateComplete: onCaptchaValidateComplete,
                        includeCaptchaFieldsInForm: true
                    });
                }

                $jq('#' + regButtonName).on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    processRegistration();
                });
            }

            var emailText = EmailAddressFieldname();
            if (typeof (emailText) !== 'undefined' && emailText !== null && $jq('#' + emailText)) {
                $jq("#" + emailText).on("blur", function() {
                    checkCommonEmailMistakes();
                });
            }

            var countrySelectName = CountryCodeFieldname();
            if (typeof(countrySelectName) !== 'undefined' && countrySelectName !== null && $jq('#' + countrySelectName).length > 0) {
                loadCountryDDL(countrySelectName);

                var postalCodeDivName = PostalCodeDivFieldname();

                if (typeof(postalCodeDivName) !== 'undefined' && postalCodeDivName !== null) {
                    addCountrySelectCityStatePostalCodeSwap(countrySelectName);
                }

                // update zip/postal code labels based on us/canada selection
                $jq('#' + countrySelectName).on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    updateZipPostalCodeLabel();
                });
            }

            loadBirthDateDropdowns();
            loadSurveyDDL();
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initialize" });
        }
    };

    var loadSurveyDDL = function() {
        try {
            if (typeof(SurveyAnswerFieldName()) !== 'undefined' && SurveyAnswerFieldName() !== null && $jq("#" + SurveyAnswerFieldName()).length > 0) {
                if ($jq("#" + SurveyAnswerFieldName())[0].length === 0) {
                    var answer = [
                        { id: "1", name: "Online Ad" },
                        { id: "2", name: "Article" },
                        { id: "3", name: "TV Commercial" },
                        { id: "4", name: "Word of Mouth" },
                        { id: "5", name: "Radio" },
                        { id: "6", name: "Other" }
                    ];

                    var defaultanswers = [{ id: "0", name: "Choose" }];

                    var answerarray = defaultanswers.concat(answer.sort(function() {
                        return 0.5 - Math.random();
                    }));

                    PeopleMedia.CP.loadDDL(SurveyAnswerFieldName(), answerarray, "id", "name");
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "loadSurveyDDL" });
        }
    };

    var getCaptchaToken = function () {
        var captchaToken = "";
        var $form = $jq("#lpsrvt");
        if ($form && $form.length > 0) {
            var $inputToken = $form.find("input[name='CaptchaToken']");
            if ($inputToken.length > 0) {
                captchaToken = $inputToken.val();
            }
        }
        return captchaToken;
    };

    var onCaptchaValidateComplete = function (err, response) {
        var thisObj = PeopleMedia.CP.Registration;
        _arkoseResponseValid = (!err && response && (response.completed || response.suppressed));
        // console.log(response);
        if (_arkoseResponseValid) {
            processRegistrationAfterCaptcha();
        } else {
            var errors = [];
            errors.push(PeopleMedia.CP.createGeneralError("Invalid captcha"));
            var onRegistrationFailure = OnRegistrationFailure();
            if (typeof (onRegistrationFailure) === 'undefined' || onRegistrationFailure === null) {
                onRegistrationFailure = function () {
                    standardOnRegistrationFailure(thisObj, errors);
                };
            }
            onRegistrationFailure(thisObj, errors);
        }
    };

    var handleRegistration = function (params) {
        try {
            var url = "/v3/lps/api/CreateMember";
            var ajaxData = {
                "Username": params.username,
                "Password": params.password,
                "EmailAddress": params.emailAddress,
                "Gender": params.gender,
                "Birthdate": params.birthDate,
                "SponsorCode": params.searchId,
                "ZipCode": params.postalCode,
                "GenderSeeking": params.genderSeek,
                "AffiliateId": params.affiliateId,
                "CountryCode": params.countryCode,
                "CaptchaToken": params.captchaToken,
                "PageDefinitionId": PeopleMedia.Configuration.pageDefinitionId,
                "PagePath": PeopleMedia.Configuration.pagePath,
                "PageVersion": PeopleMedia.Configuration.pageVersion,
                "VisitorId": PeopleMedia.Configuration.visitorId
            };

            var startTime = new Date().getTime();
            var timeoutValue = 60000;
            jQuery.ajax({
                headers: PeopleMedia.CP.LpsPostbackHeader(),
                type: "POST",
                url: url,
                data: JSON.stringify(ajaxData),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    handleRegistrationComplete(null, response, params);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var endTime = new Date().getTime();
                    var duration = (endTime - startTime);
                    var err = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                    if (!err.IsCancelled) {
                        PeopleMedia.CP.logAjax({ oid: Oid, method: "handleRegistration", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                    }
                    handleRegistrationComplete(err, null, params);
                },
                async: true,
                cache: false,
                timeout: timeoutValue
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "handleRegistration" });
            handleRegistrationComplete(PeopleMedia.CP.createErrorObject(ex), null, params);
        }
    };

    var handleRegistrationComplete = function (err, response, params) {
        var defaultError = "We are unable to process your registration at this time. Please try again later. We apologize for any inconvenience.";
        var errors = [];
        var wrappedResponse = {
            originalResponse: response,
            publicMemberId: null,
            message: null,
            success: false
        };
        if (err || !response || response.status !== "Success" || !response.PublicMemberId) {
            wrappedResponse.message = (response && response.Message) ? response.Message : defaultError;
            errors.push(PeopleMedia.CP.createGeneralError(wrappedResponse.message));
            PeopleMedia.CP.trackRegistrationFailure(errors);
            RegistrationFailed(true);
            if (params && typeof (params.onComplete) === "function") {
                wrappedResponse.errors = errors;
                params.onComplete(err, wrappedResponse, params);
            }
            return;
        }

        var memberId = response.PublicMemberId;
        var emailAddress = (EmailAddress() || "").trim();
        incrementIsRegisteredLoginCounter();

        PeopleMedia.CP.getSelfProfileComplete({},
            function (profileErr, getSelfProfileCompleteResponse) {
                if (profileErr === null && getSelfProfileCompleteResponse) {
                    var communityMember =
                        PeopleMedia.CP.convertSelfProfileCompleteToCommunityMember(
                            getSelfProfileCompleteResponse,
                            memberId,
                            emailAddress);
                    _registrationData = communityMember;

                    PeopleMedia.CP.trackRegistrationEventAnalytics();
                    PeopleMedia.CP.trackRegistrationSuccess(communityMember);
                    $jq(PeopleMedia).trigger('PeopleMedia.CP.onRegistrationSuccess',
                        communityMember);

                    if (params && typeof (params.onComplete) === "function") {
                        wrappedResponse.data = communityMember;
                        wrappedResponse.publicMemberId = memberId;
                        wrappedResponse.success = true;
                        params.onComplete(err, wrappedResponse, params);
                    }
                } else {
                    errors.push(PeopleMedia.CP.createGeneralError(defaultError));
                    PeopleMedia.CP.trackRegistrationFailure(errors);
                    RegistrationFailed(true);
                    if (params && typeof (params.onComplete) === "function") {
                        wrappedResponse.success = false;
                        wrappedResponse.message = defaultError;
                        wrappedResponse.getSelfProfileCompleteResponse = getSelfProfileCompleteResponse;
                        params.onComplete(profileErr, wrappedResponse, params);
                    }
                }
            });
        return;
    };

    var validate = function() {
        try {
            var errors = [];
            // these validations should all run synchronously
            errors = errors.concat(validateUsername());
            errors = errors.concat(validatePassword());
            errors = errors.concat(validateEmailAddress());
            errors = errors.concat(validateCountryCode());
            errors = errors.concat(validatePostalCodeFormat());
            errors = errors.concat(validateGender());
            errors = errors.concat(validateBirthDay());
            errors = errors.concat(validateTermsAndConditions());
            errors = errors.concat(validateEmailAddressConfirmation());
            errors = errors.concat(validateCaptcha());
            return errors;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validate" });
            return [];
        }
    };

    var validateCaptcha = function () {

        try {
            if (typeof(window.grecaptcha) !== "undefined") {
                var v = window.grecaptcha.getResponse();
                if (typeof(v) !== "undefined" && v !== null && v.length > 0) {
                    return [];
                } else {
                    return [{ Field: "gCaptcha", Text: PeopleMedia.CP.ClientMessages.RegCaptcha }];
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateCaptcha" });
        }

        return [];
    };

    var validateUsername = function() {
        try {
            var trimmedUsername = (Username() || "").trim();
            if (typeof (Username()) === 'undefined' || Username() === null || Username() === '' || trimmedUsername === '') {
                return [{ Field: UsernameFieldname(), Text: PeopleMedia.CP.ClientMessages.RegHandle }];
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateUsername" });
            return [];
        }
    };

    var validatePassword = function() {
        try {
            if (typeof (Password()) === 'undefined' || Password() === null || Password() === '') {
                return [{ Field: PasswordFieldname(), Text: PeopleMedia.CP.ClientMessages.LoginPassword }];
            }
            var trimmedPassword = (Password() || "").trim();
            if (trimmedPassword === "") {
                return [{ Field: PasswordFieldname(), Text: "Password cannot contain spaces - Try again." }];
            }

            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validatePassword" });
            return [];
        }
    };

    var validateUsernameAndPassword = function(onValidationComplete) {
        var errors = [];
        try {
            var username = (Username() || "").trim();
            var password = (Password() || "");
            var trimmedPassword = password.trim();

            if (username.length === 0) {
                errors.push({ Field: UsernameFieldname(), Text: PeopleMedia.CP.ClientMessages.RegHandle });
            }
            if (password.length === 0) {
                errors.push({ Field: PasswordFieldname(), Text: PeopleMedia.CP.ClientMessages.LoginPassword });
            }
            if (password.length > 0 && trimmedPassword.length !== password.length) {
                errors.push({ Field: PasswordFieldname(), Text: "Password cannot contain spaces - Try again." });
            }
            if (errors.length > 0) {
                validateUsernameFormat_complete(onValidationComplete, errors, null);

                // Return missing username and pasword synchronously
                return errors;
            }

            if (typeof (onValidationComplete) === "function" && errors.length === 0) {
                // call validateUsernameFormat first with default values (no check for duplicate usernames)
                validateUsernameFormat(function(validateUsernameErrors, validateUsernameData) {

                    // if username without duplicate check is successful, then call validatePasswordFormat
                    if (validateUsernameData && validateUsernameData.IsValid === true) {

                        validatePasswordFormat(function(validatePasswordErrors, validatePasswordData) {
                            // there was a password error (or site allows duplicate usernames), so call the the onValidationComplete callback
                            onValidationComplete(validatePasswordErrors, validatePasswordData);
                        });

                    } else {
                        // there was a username formatting error, so skip the remaining validations and just call the the onValidationComplete callback
                        onValidationComplete(validateUsernameErrors, validateUsernameData);
                    }
                });
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateUsernameAndPassword" });
            return [];
        }
    };

    var validateUsernameFormat = function(onValidationComplete) {
        var errors = [];
        try {
            var username = (Username() || "").trim();
            var password = (Password() || "");
            var skipDuplicateUsernameValidation = true;

            if (username.length === 0) {
                errors.push({ Field: UsernameFieldname(), Text: PeopleMedia.CP.ClientMessages.RegHandle });
                validateUsernameFormat_complete(onValidationComplete, errors, null);

                // Return missing pasword synchronously
                return errors;
            }

            if (typeof (onValidationComplete) === "function" && username.length > 0) {
                PeopleMedia.CP.ui_busy();

                trackRegistrationEventValidateUsername(username);

                var url = "/v3/lps/api/ValidateUsername";
                var ajaxData = {
                    "Username": username,
                    "Password": password,
                    "SkipDuplicateUsernameValidation": skipDuplicateUsernameValidation
                };

                var startTime = new Date().getTime();
                var timeoutValue = 30000;
                jQuery.ajax({
                    headers: PeopleMedia.CP.LpsPostbackHeader(),
                    type: "POST",
                    url: url,
                    data: JSON.stringify(ajaxData),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        validateUsernameFormat_complete(onValidationComplete, [], data);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        var endTime = new Date().getTime();
                        var duration = (endTime - startTime);
                        var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                        if (!data.IsCancelled) {
                            PeopleMedia.CP.logAjax({ oid: Oid, method: "validateUsernameFormat", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                        }
                        validateUsernameFormat_complete(onValidationComplete, [], data);
                    },
                    async: true,
                    cache: false,
                    timeout: timeoutValue
                });
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateUsernameFormat" });
            return [];
        }
    };

    var validateUsernameFormat_complete = function(onValidationComplete, errors, data) {
        try {
            errors = errors || [];
            PeopleMedia.CP.ui_done();

            if (errors.length === 0) {
                if (typeof (data) === "undefined" || data === null || data.IsValid !== true) {
                    if (data && data.Fault && !data.Fault.IsCancelled) {
                        errors.push(PeopleMedia.CP.convertFaultToError(data.Fault, UsernameFieldname()));
                    } else if (data && data.Message) {
                        errors.push({ Field: UsernameFieldname(), Text: data.Message });
                    }
                }
            }
            if (typeof (onValidationComplete) === "function") {
                onValidationComplete(errors, data);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateUsernameFormat_complete" });
        }
    };

    var trackRegistrationEventValidateUsername = function (username, completeFunction) {
        try {
            if (username) {
                PeopleMedia.CP.trackMemberRegistrationEvent("ValidateUsername", username, completeFunction);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "trackRegistrationEventValidateUsername" });
        }
    };

    var validatePasswordFormat = function(onValidationComplete) {
        var errors = [];
        try {
            var username = (Username() || "").trim();
            var password = (Password() || "");

            if (password.length === 0) {
                errors.push({ Field: PasswordFieldname(), Text: PeopleMedia.CP.ClientMessages.LoginPassword });
                validatePasswordFormat_complete(onValidationComplete, errors, null);

                // Return missing pasword synchronously
                return errors;
            }

            if (typeof (onValidationComplete) === "function" && password.length > 0) {
                PeopleMedia.CP.ui_busy();

                var url = "/v3/lps/api/ValidatePassword";
                var ajaxData = {
                    "Username": username,
                    "Password": password
                };

                var startTime = new Date().getTime();
                var timeoutValue = 30000;
                jQuery.ajax({
                    headers: PeopleMedia.CP.LpsPostbackHeader(),
                    type: "POST",
                    url: url,
                    data: JSON.stringify(ajaxData),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        validatePasswordFormat_complete(onValidationComplete, [], data);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        var endTime = new Date().getTime();
                        var duration = (endTime - startTime);
                        var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                        if (!data.IsCancelled) {
                            PeopleMedia.CP.logAjax({ oid: Oid, method: "validatePasswordFormat", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                        }
                        validatePasswordFormat_complete(onValidationComplete, [], data);
                    },
                    async: true,
                    cache: false,
                    timeout: timeoutValue
                });
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validatePasswordFormat" });
            return [];
        }
    };

    var validatePasswordFormat_complete = function(onValidationComplete, errors, data) {
        try {
            errors = errors || [];
            PeopleMedia.CP.ui_done();

            if (errors.length === 0) {
                if (typeof (data) === "undefined" || data === null || data.IsValid !== true) {
                    if (data && data.Fault && !data.Fault.IsCancelled) {
                        errors.push(PeopleMedia.CP.convertFaultToError(data.Fault, PasswordFieldname()));
                    } else if (data && data.Message) {
                        errors.push({ Field: PasswordFieldname(), Text: data.Message });
                    }
                }
            }
            if (typeof (onValidationComplete) === "function") {
                onValidationComplete(errors, data);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validatePasswordFormat_complete" });
        }
    };

    var validateUsernameFormatSimple = function(input) {
        try {
            var checkUsername = /^[A-Za-z0-9 '-]+$/g;
            var alpha = /[A-Za-z]/;
            if (typeof (input) === "undefined" || input === null || input === "") {
                return false;
            }
            if (input.length < 2 || input.length > 16) {
                return false;
            }
            var validFormat = checkUsername.test(input);
            if (!validFormat) {
                return false;
            }
            if (input.indexOf("  ") >= 0) {
                return false;
            }
            if (input.indexOf("--") >= 0) {
                return false;
            }
            if (input.indexOf("''") >= 0) {
                return false;
            }
            if ((input.match(/ /g) || []).length > 2) {
                return false;
            }
            if ((input.match(/-/g) || []).length > 2) {
                return false;
            }
            if ((input.match(/'/g) || []).length > 2) {
                return false;
            }
            if (!alpha.test(input[0])) {
                return false;
            }
            if (!alpha.test(input[input.length - 1])) {
                return false;
            }
            return true;
        } catch (ex) {
            return false;
        }
    };

    var validatePasswordFormatSimple = function(input) {
        try {
            // intentionally longer than the minimum password length 
            // so checkmark while typing isn't displayed for short passwords
            var checkPassword = /^[A-Za-z0-9!"#$%&'()*+,\-.\/:;<=>?@\[\]\\^_`{|}~]{8,16}$/;
            return checkPassword.test(input);
        } catch (ex) {
            return false;
        }
    };

    var validateEmailAddress = function() {
        try {
            if (typeof (EmailAddress()) === 'undefined' || EmailAddress() === null || EmailAddress() === '') {
                return [{ Field: EmailAddressFieldname(), Text: PeopleMedia.CP.ClientMessages.RegEmail }];
            }
            var regex = /^['_a-z0-9-]+(\.['_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*\.(([a-z]{2,3})|(aero|coop|info|museum|name))$/i;
            if (!regex.test(EmailAddress())) {
                return [{ Field: EmailAddressFieldname(), Text: "Please enter a valid email address." }];
            } else if (EmailAddress().length > 50) {
                return [
                    {
                        Field: EmailAddressFieldname(),
                        Text: "Please enter an email address less than 50 characters."
                    }
                ];
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateEmailAddress" });
            return [];
        }
    };

    var checkCommonEmailMistakes = function() {
        try {
            if (typeof (PeopleMedia.CP.InvalidEmailDomainCheckEnabled()) !== 'undefined' &&
                PeopleMedia.CP.InvalidEmailDomainCheckEnabled()) {

                var isBadEmail = false;
                OriginalEmailAddress = EmailAddress();
                var badAddresses = [
                    { id: 'aol.con', correct: 'aol.com' },
                    { id: '-aol.com', correct: 'aol.com' },
                    { id: 'comast.net', correct: 'comcast.net' },
                    { id: 'gmail.con', correct: 'gmail.com' },
                    { id: 'gmail.co', correct: 'gmail.com' },
                    { id: 'gmal.com', correct: 'gmail.com' },
                    { id: 'gmial.com', correct: 'gmail.com' },
                    { id: 'gmail.cim', correct: 'gmail.com' },
                    { id: 'ail.com', correct: 'gmail.com' },
                    { id: 'gmaill.com', correct: 'gmail.com' },
                    { id: 'gmail.com.com', correct: 'gmail.com' },
                    { id: '-gmail.com', correct: 'gmail.com' },
                    { id: 'hotmai.com', correct: 'hotmail.com' },
                    { id: 'hoymail.com', correct: 'hotmail.com' },
                    { id: 'hotmail.con', correct: 'hotmail.com' },
                    { id: 'hotmal.com', correct: 'hotmail.com' },
                    { id: 'homail.com', correct: 'hotmail.com' },
                    { id: 'hotmail.net', correct: 'hotmail.com' },
                    { id: 'hotmial.com', correct: 'hotmail.com' },
                    { id: 'otmail.com', correct: 'hotmail.com' },
                    { id: 'hotmaill.com', correct: 'hotmail.com' },
                    { id: 'HOTAIL.COM', correct: 'hotmail.com' },
                    { id: 'htomail.com', correct: 'hotmail.com' },
                    { id: 'hotmaol.com', correct: 'hotmail.com' },
                    { id: 'hotmail.com.com', correct: 'hotmail.com' },
                    { id: 'hotamil.com', correct: 'hotmail.com' },
                    { id: 'hotamail.com', correct: 'hotmail.com' },
                    { id: 'hotmeil.com', correct: 'hotmail.com' },
                    { id: 'holmail.com', correct: 'hotmail.com' },
                    { id: 'yahoo.co', correct: 'yahoo.com' },
                    { id: 'yahoo.con', correct: 'yahoo.com' },
                    { id: 'yahoo.cm', correct: 'yahoo.com' },
                    { id: 'yahoo.om', correct: 'yahoo.com' },
                    { id: 'tahoo.com', correct: 'yahoo.com' },
                    { id: 'yahoo.cpm', correct: 'yahoo.com' },
                    { id: 'yahoo.com.com', correct: 'yahoo.com' },
                    { id: 'yahhoo.com', correct: 'yahoo.com' },
                    { id: 'yahoo.cim', correct: 'yahoo.com' },
                    { id: '-ahoo.com', correct: 'yahoo.com' },
                ];

                var badAddress;
                var domain = EmailAddress().split('@');
                if (typeof (domain[1]) !== 'undefined' && domain[1] !== null) {
                    badAddress = badAddresses.filter(function(address) {
                        return address.id === domain[1].toLowerCase();
                    });
                    if (typeof(badAddress) !== 'undefined' && badAddress !== null && badAddress.length > 0) {
                        isBadEmail = true;
                    }
                }

                if (isBadEmail) {
                    //$jq("#" + EmailAddressFieldname()).val('Bad Email');
                    var correctAddress = domain[0] + "@" + badAddress[0].correct;
                    PeopleMedia.CP.Messaging.showEmailError([
                        {
                            Field: EmailAddressFieldname(),
                            Text: "Did you mean: " + correctAddress,
                            Value: correctAddress
                        }
                    ]);
                    var emailAddressFieldName = EmailAddressFieldname();
                    var originalEmailAddress = OriginalEmailAddress;
                    $jq('#correctEmailAddressChkBox').change(function() {
                        if ($jq('#correctEmailAddressChkBox').is(':checked')) {
                            $jq("#" + emailAddressFieldName).val(correctAddress);
                        } else {
                            $jq("#" + emailAddressFieldName).val(originalEmailAddress);
                        }
                    });
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "checkCommonEmailMistakes" });
            return [];
        }
    };

    var validateEmailAddressConfirmation = function() {
        try {
            if (HasEmailAddressConfirmationField()) {
                if (EmailAddressConfirmation() !== EmailAddress()) {
                    return [{ Field: EmailAddressConfirmationFieldname(), Text: "Email addresses do not match." }];
                }
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateEmailAddressConfirmation" });
            return [];
        }
    };

    var validateEmailAddressFormat = function(input) {
        var checkEmail =
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return checkEmail.test(input);
    };

    var validateCountryCode = function() {
        try {
            if (typeof (CountryCode()) === 'undefined' || CountryCode() === null || CountryCode() === '') {
                return [{ Field: CountryCodeFieldname(), Text: PeopleMedia.CP.ClientMessages.RegCountryCode }];
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateCountryCode" });
            return [];
        }
    };

    // returns synchronously
    var validatePostalCodeFormat = function () {
        var errors = [];
        try {
            var countryCode = (CountryCode() || "").trim().toUpperCase();
            var postalCode = (PostalCode() || "").trim();
            PostalCode(postalCode); // set the postal code to the trimmed version

            if (postalCode.length < 5 ||
                (countryCode === "US" && !validatePostalCodeFormatIsUsa(postalCode)) ||
                (countryCode === "CA" && !validatePostalCodeFormatIsCanada(postalCode))) {
                errors.push({ Field: PostalCodeFieldname(), Text: PeopleMedia.CP.ClientMessages.RegPostalcode });
                return errors;
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validatePostalCodeFormat" });
            return [];
        }
    };

    // returns asynchronously
    var validatePostalCode = function(onValidationComplete) {
        try {
            var countryCode = (CountryCode() || "").trim().toUpperCase();
            var postalCode = (PostalCode() || "").trim();
            PostalCode(postalCode); // set the postal code to the trimmed version
            
            if (postalCode.length < 5 ||
                (countryCode === "US" && !validatePostalCodeFormatIsUsa(postalCode)) ||
                (countryCode === "CA" && !validatePostalCodeFormatIsCanada(postalCode))) {
                var errors = [];
                errors.push({ Field: PostalCodeFieldname(), Text: PeopleMedia.CP.ClientMessages.RegPostalcode });
                validatePostalCode_complete(onValidationComplete, errors, null);
                return;
            }

            if (typeof (onValidationComplete) === "function" && postalCode.length > 0) {

                PeopleMedia.CP.ui_busy();

                var url = "/v3/lps/api/ValidatePostalCode";
                var ajaxData = {
                    "PostalCode": postalCode,
                    "CountryCode": countryCode
                };

                var startTime = new Date().getTime();
                var timeoutValue = 15000;
                jQuery.ajax({
                    headers: PeopleMedia.CP.LpsPostbackHeader(),
                    type: "POST",
                    url: url,
                    data: JSON.stringify(ajaxData),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function (data) {                                
                        validatePostalCode_complete(onValidationComplete, [], data);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        var endTime = new Date().getTime();
                        var duration = (endTime - startTime);
                        var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                        if (!data.IsCancelled) {
                            PeopleMedia.CP.logAjax({ oid: Oid, method: "validatePostalCode", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                        }
                        validatePostalCode_complete(onValidationComplete, [], data);
                    },
                    async: true,
                    cache: false,
                    timeout: timeoutValue
                });
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validatePostalCode" });
        }
    };

    var validatePostalCode_complete = function(onValidationComplete, errors, data) {
        try {
            errors = errors || [];
            PeopleMedia.CP.ui_done();
            if (errors.length === 0) {
                if (typeof (data) === "undefined" || data === null || data.IsValid !== true) {
                    if (data && data.Fault && !data.Fault.IsCancelled) {
                        errors.push(PeopleMedia.CP.convertFaultToError(data.Fault, PostalCodeFieldname()));
                    } else {
                        errors.push({
                            Field: PostalCodeFieldname(),
                            Text: PeopleMedia.CP.ClientMessages.RegPostalcode
                        });
                    }
                }
            }
            if (typeof (onValidationComplete) === "function") {
                onValidationComplete(errors);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validatePostalCode_complete" });
        }
    };

    var getPostalCodeLocation = function (onGetPostalCodeLocationComplete) {
        try {
            var countryCode = (CountryCode() || "").trim().toUpperCase();
            var postalCode = (PostalCode() || "").trim();

            if (typeof (onGetPostalCodeLocationComplete) === "function" &&
                postalCode.length >= 5 &&
                (countryCode === "US" || countryCode === "CA")) {

                PeopleMedia.CP.ui_busy();

                var url = "/v3/lps/api/GetLocationByPostalCode";
                var ajaxData = {
                    "PostalCode": postalCode,
                    "CountryCode": countryCode
                };
                var startTime = new Date().getTime();
                var timeoutValue = 3000;
                jQuery.ajax({
                    headers: PeopleMedia.CP.LpsPostbackHeader(),
                    type: "POST",
                    url: url,
                    data: JSON.stringify(ajaxData),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function (data) {
                        getPostalCodeLocationComplete(null, data, onGetPostalCodeLocationComplete);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        var endTime = new Date().getTime();
                        var duration = (endTime - startTime);
                        var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                        if (!data.IsCancelled) {
                            PeopleMedia.CP.logAjax({ oid: Oid, method: "getPostalCodeLocation", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                        }
                        getPostalCodeLocationComplete(data, null, onGetPostalCodeLocationComplete);
                    },
                    async: true,
                    cache: false,
                    timeout: timeoutValue
                });
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getPostalCodeLocation" });
            return getPostalCodeLocationComplete(PeopleMedia.CP.createErrorObject(ex), null, onGetPostalCodeLocationComplete);
        }
    };

    var getPostalCodeLocationComplete = function (err, data, onGetPostalCodeLocationComplete) {
        try {
            PeopleMedia.CP.ui_done();

            var response = {};

            if (!err && data && data.status === "Success" && data.Location) {
                response.Location = data.Location;
            } else {
                if (err) {
                    response.Error = err;
                }
            }

            if (typeof (onGetPostalCodeLocationComplete) === "function") {
                onGetPostalCodeLocationComplete(response);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getPostalCodeLocationComplete" });
        }
    };

    var validatePostalCodeFormatIsUsa = function(input) {
        var checkPostalCode = /^[0-9]{5}$/;
        return checkPostalCode.test(input);
    };

    var validatePostalCodeFormatIsCanada = function(input) {
        var checkPostalCodeCanada = /^[ABCEGHJKLMNPRSTVXY][0-9][A-Z][\s]*[0-9][A-Z][0-9]$/i;
        return checkPostalCodeCanada.test(input);
    };

    var setBackgroundCheckDisclaimer = function (onComplete) {
        determinePostalCodeLocation(function (postalLocationResponse) {
            if (postalLocationResponse && postalLocationResponse.showDisclaimer) {
                $jq(".criminalcheck").show();
            } else {
                $jq(".criminalcheck").hide();
            }
            if (typeof (onComplete) === "function") {
                onComplete(postalLocationResponse);
            }
        });
    };

    var determinePostalCodeLocation = function (onComplete) {
        try {
            getPostalCodeLocation(function (response) {
                var stateList = ["IL", "NJ"];
                var showDisclaimer = !response ||
                    !response.Location ||
                    !response.Location.StateProvince ||
                    stateList.indexOf(response.Location.StateProvince) >= 0;

                if (typeof (onComplete) === "function") {
                    onComplete({
                        showDisclaimer: showDisclaimer,
                        location: response.Location
                    });
                }
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "determinePostalCodeLocation" });
        }
    };

    var validateGender = function() {
        try {
            if (HasGenderCombinedField()) {
                if (typeof (GenderCombinedSelf()) === 'undefined' || GenderCombinedSelf() === null || GenderCombinedSelf() === '') {
                    return [{ Field: GenderCombinedFieldname(), Text: PeopleMedia.CP.ClientMessages.RegGender }];
                }
            } else if (typeof (Gender()) === 'undefined' || Gender() === null || Gender() === '') {
                return [{ Field: GenderFieldname(), Text: PeopleMedia.CP.ClientMessages.RegGender }];
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateGender" });
            return [];
        }
    };

    var isDateValid = function (year, month, day) {
        try {
            year = typeof (year) === 'string' ? parseInt(year, 10) : year;
            month = typeof (month) === 'string' ? parseInt(month, 10) : month;
            day = typeof (day) === 'string' ? parseInt(day, 10) : day;
            year = (year < 1000) ? year + 1900 : year;
            month = month - 1; // javascript month range : 0- 11
            var tempDate = new Date(year, month, day);
            if ((tempDate.getFullYear() === year) && (month === tempDate.getMonth()) && (day === tempDate.getDate())) {
                return true;
            }
        } catch (ex) {
        }
        return false;
    };

    var validateBirthDay = function() {
        try {
            var errors = [];
            var birthDate = (BirthDate() || "").trim();
            var bd;
            var birthMonth;
            var birthDay;
            var birthYear;
            var birthMonthFieldname;
            var birthDayFieldname;
            var birthYearFieldname;
            var hasCombinedBirthDate = HasBirthDateCombinedField();
            if (hasCombinedBirthDate) {
                bd = PeopleMedia.CP.Utilities.parseDateString(birthDate);
                if (bd) {
                    birthMonth = bd.dtMonth;
                    birthDay = bd.dtDay;
                    birthYear = bd.dtYear;
                }
                birthMonthFieldname = BirthDateCombinedFieldname();
                birthDayFieldname = BirthDateCombinedFieldname();
                birthYearFieldname = BirthDateCombinedFieldname();
            } else {
                birthMonth = BirthMonth();
                birthDay = BirthDay();
                birthYear = BirthYear();
                birthMonthFieldname = BirthMonthFieldname();
                birthDayFieldname = BirthDayFieldname();
                birthYearFieldname = BirthYearFieldname();
            }

            if (typeof (birthMonth) === 'undefined' || birthMonth === null || birthMonth === '' || birthMonth === '0' || birthMonth === 0) {
                errors.push({ Field: birthMonthFieldname, Text: PeopleMedia.CP.ClientMessages.RegBirthGeneric });
            } else if (typeof (birthDay) === 'undefined' || birthDay === null || birthDay === '' || birthDay === '0' || birthDay === 0) {
                errors.push({ Field: birthDayFieldname, Text: PeopleMedia.CP.ClientMessages.RegBirthGeneric });
            } else if (typeof (birthYear) === 'undefined' || birthYear === null || birthYear === '' || birthYear === '0' || birthYear === 0) {
                errors.push({ Field: birthYearFieldname, Text: PeopleMedia.CP.ClientMessages.RegBirthGeneric });
            } else if (typeof(birthDate) === 'undefined' || birthDate === null || birthDate === '') {
                errors.push({ Field: birthMonthFieldname, Text: PeopleMedia.CP.ClientMessages.RegBirthGeneric });
            } else if (!isDateValid(birthYear, birthMonth, birthDay)) {
                errors.push({
                    Field: birthDayFieldname,
                    Text: "The birth date entered is invalid. Please re-enter your birth date."
                });
            } else {
                var today = new Date();
                var nowyear = today.getFullYear();
                var age = nowyear - birthYear;

                if (age < 1) {
                    errors.push({
                        Field: birthDayFieldname,
                        Text: "The birth date entered is invalid. Please re-enter your birth date."
                    });
                }
            }
            return errors;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateBirthDay" });
            return [];
        }
    };

    var validateBirthDayFormat = function(input) {
        var result = { isValid: false, validDate: false };
        try {
            var birthDate = (input || "").trim();
            var bd = PeopleMedia.CP.Utilities.parseDateString(birthDate);
            if (bd && bd.dtMonth && bd.dtDay && bd.dtYear && isDateValid(bd.dtYear, bd.dtMonth, bd.dtDay)) {
                var today = new Date();
                var nowyear = today.getFullYear();
                var age = nowyear - bd.dtYear;
                if (age > 0) {
                    result.validDate = true;
                    result.isValid = true;
                }
            }
        } catch (ex) {
            result.isValid = false;
            result.validDate = false;
            result.error = ex;
        }
        return result;
    };

    var validateTermsAndConditions = function() {
        try {
            if (typeof(TermsAndConditions()) === 'undefined' || TermsAndConditions() === null || TermsAndConditions() === false) {
                return [{ Text: PeopleMedia.CP.ClientMessages.RegTermsAndConditions }];
            }
            return [];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateTermsAndConditions" });
            return [];
        }
    };

    var processRegistration = PeopleMedia.CP.Utilities.debounce(function() {
        try {
            var thisObj = PeopleMedia.CP.Registration;

            $jq("#" + RegistrationButtonFieldname()).fadeTo('fast', '0.3');

            if ($jq('#' + CountryCodeFieldname()).innerWidth() <= 0 && typeof (PostalCode()) !== 'undefined' && PostalCode() !== null && PostalCode().length > 0) {
                if (PostalCode().length > 5) {
                    $jq('#' + CountryCodeFieldname()).val('CA');
                } else {
                    $jq('#' + CountryCodeFieldname()).val('US');
                }
            }

            var errors = [];
            errors = validate();

            if (errors.length === 0) {
                if (PeopleMedia.Configuration.isArkoseCaptchaRequired === true &&
                    PeopleMedia.CP.ArkoseCaptcha.scriptsReady) {
                    PeopleMedia.CP.ArkoseCaptcha.execute();
                    return;
                }
                processRegistrationAfterCaptcha();
            } else {
                var onRegistrationFailure = OnRegistrationFailure();
                if (typeof (onRegistrationFailure) === 'undefined' || onRegistrationFailure === null) {
                    onRegistrationFailure = function () {
                        standardOnRegistrationFailure(thisObj, errors);
                    };
                }
                onRegistrationFailure(thisObj, errors);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "processRegistration" });
            PeopleMedia.CP.ui_done();
        }
    }, 1000, true);

    var processRegistrationAfterCaptcha = PeopleMedia.CP.Utilities.debounce(function () {
        try {
            var thisObj = PeopleMedia.CP.Registration;

            if (registrationInProgress) {
                return;
            }

            registrationInProgress = true;

            // PeopleMedia.CP.ui_busy();
            PeopleMedia.CP.Animations.showLoader({ legacy: false });

             var username = (Username() || "").trim();
            var password = (Password() || "");
            var emailAddress = (EmailAddress() || "").trim();
            var countryCode = (CountryCode() || "").trim().toUpperCase();
            var postalCode = (PostalCode() || "").trim();
            var gender = Gender();
            var genderSeek = GenderSeek();
            var birthDate = BirthDate();
            var searchId =
                (typeof (PeopleMedia.CP.SearchID()) !== "undefined" && PeopleMedia.CP.SearchID() !== null)
                    ? PeopleMedia.CP.SearchID()
                    : 999;
            var affiliateId =
                (typeof (PeopleMedia.CP.AffiliateID()) !== "undefined" && PeopleMedia.CP.AffiliateID() !== null)
                    ? PeopleMedia.CP.AffiliateID()
                    : null;

            if (HasGenderCombinedField()) {
                gender = GenderCombinedSelf();
                genderSeek = GenderCombinedSeeking();
            }

            PeopleMedia.CP.GenderID(gender);
            PeopleMedia.CP.GenderSeekID(genderSeek);

            var captchaToken = getCaptchaToken();

            var params = {
                username: username,
                password: password,
                emailAddress: emailAddress,
                gender: gender,
                birthDate: birthDate,
                searchId: searchId,
                postalCode: postalCode,
                genderSeek: genderSeek,
                affiliateId: affiliateId,
                countryCode: countryCode,
                captchaToken: captchaToken,
                onComplete: function (err, response) {
                    registrationInProgress = false;
                    // PeopleMedia.CP.ui_done();
                    PeopleMedia.CP.Animations.hideLoader();

                    if (err || !response || !response.success) {
                        var errors = response && response.errors ? response.errors : [];
                        if (errors.length === 0) {
                            var message = response && response.message ? response.message : "We are unable to process your registration at this time. Please try again later. We apologize for any inconvenience.";
                            errors.push(PeopleMedia.CP.createGeneralError(message));
                        }
                        var onRegistrationFailure = OnRegistrationFailure();
                        if (typeof (onRegistrationFailure) === 'undefined' || onRegistrationFailure === null) {
                            onRegistrationFailure = function () {
                                standardOnRegistrationFailure(thisObj, errors);
                            };
                        }
                        onRegistrationFailure(thisObj, errors);
                        return;
                    }

                    var onRegistrationSuccess = OnRegistrationSuccess();
                    if (typeof (onRegistrationSuccess) === 'undefined' || onRegistrationSuccess === null) {
                        onRegistrationSuccess = function () {
                            standardOnRegistrationSuccess(thisObj, response);
                        };
                    }
                    onRegistrationSuccess(thisObj, response);
                }
            };

            handleRegistration(params);
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "processRegistrationAfterCaptcha" });
            registrationInProgress = false;
            // PeopleMedia.CP.ui_done();
            PeopleMedia.CP.Animations.hideLoader();
        }
    }, 1000, true);

    var standardOnRegistrationSuccess = function(sender, data) {
        try {
            PeopleMedia.CP.gotoSite(data.AutoLoginUrl + "&evt=2");
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "standardOnRegistrationSuccess" });
        }
    };

    var standardOnRegistrationFailure = function(sender, errors) {
        try {
            $jq("#" + RegistrationButtonFieldname()).fadeTo('fast', '1.0');

            PeopleMedia.CP.Messaging.show(errors);
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "standardOnRegistrationFailure" });
        }
    };

    var incrementIsRegisteredLoginCounter = function() {
        try {
            var counter = PeopleMedia.Net.readCookie('IsRegisteredLoginCounter');
            var loginCount = (typeof(counter) !== 'undefined' && counter !== null) ? parseInt(counter, 10) : 0;
            if (isNaN(loginCount)) {
                loginCount = 0;
            }
            loginCount++;
            PeopleMedia.Net.createCookie('IsRegisteredLoginCounter', loginCount.toString());
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "incrementIsRegisteredLoginCounter" });
            return false;
        }
    };

    var addCountrySelectCityStatePostalCodeSwap = function(countrySelectFieldname) {
        try {
            $jq('#' + countrySelectFieldname).on('change',
                function() {
                    showZipPostalCodeCityState();
                });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "addCountrySelectCityStatePostalCodeSwap" });
        }
    };

    var loadBirthDateDropdowns = function() {
        try {
            var months;
            var i;
            if (typeof(BirthMonthFieldname()) !== 'undefined' && BirthMonthFieldname() !== null && $jq("#" + BirthMonthFieldname()).length > 0) {
                if ($jq("#" + BirthMonthFieldname())[0].length === 0) {
                    months = [
                        { id: "0", name: "Month" }, { id: "1", name: "January" }, { id: "2", name: "February" },
                        { id: "3", name: "March" }, { id: "4", name: "April" },
                        { id: "5", name: "May" }, { id: "6", name: "June" }, { id: "7", name: "July" },
                        { id: "8", name: "August" }, { id: "9", name: "September" },
                        { id: "10", name: "October" }, { id: "11", name: "November" }, { id: "12", name: "December" }
                    ];
                    PeopleMedia.CP.loadDDL(BirthMonthFieldname(), months, "id", "name");
                }
            }

            if (typeof(BirthDayFieldname()) !== 'undefined' && BirthDayFieldname() !== null && $jq("#" + BirthDayFieldname()).length > 0) {
                if ($jq("#" + BirthDayFieldname())[0].length === 0) {
                    months = [{ id: "0", name: "Day" }];
                    for (i = 1; i <= 31; ++i) {
                        months[i] = { id: i.toString(), name: i.toString() };
                    }
                    PeopleMedia.CP.loadDDL(BirthDayFieldname(), months, "id", "name");
                }
            }

            if (typeof(BirthYearFieldname()) !== 'undefined' && BirthYearFieldname() !== null && $jq("#" + BirthYearFieldname()).length > 0) {
                if ($jq("#" + BirthYearFieldname())[0].length > 0) {
                    $jq("#" + BirthYearFieldname() + " >option").remove();
                }
                var maxYear = (new Date()).getFullYear();
                var minYear = (new Date()).getFullYear() - 120 < 1900 ? 1900 : (new Date()).getFullYear() - 120;
                var years = [{ id: "0", name: "Year" }];
                for (i = minYear; i <= maxYear; ++i) {
                    years[i - minYear + 1] = { id: i.toString(), name: i.toString() };
                }
                PeopleMedia.CP.loadDDL(BirthYearFieldname(), years, "id", "name");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "loadBirthDateDropdowns" });
        }
    };

    var loadQuestions = function(options) {
        try {
            if (typeof options !== "object" || options === null) {
                options = {};
            }

            _questions = [];
            _questions.push({
                "QuestionID": 991,
                "QuestionText": "Country",
                "DefaultValue": null,
                "GetValue": function() {
                    return CountryCode();
                }
            });

            _questions.push({
                "QuestionID": 992,
                "QuestionText": "PostalCode",
                "DefaultValue": null,
                "GetValue": function() {
                    return PostalCode();
                }
            });
            _questions.push({
                "QuestionID": 993,
                "QuestionText": "BirthDate",
                "DefaultValue": null,
                "GetValue": function() {
                    return BirthDate();
                }
            });
            if (options.splitUsernamePassword === true) {
                _questions.push({
                    "QuestionID": 1000,
                    "DefaultValue": null,
                    "QuestionText": "Password",
                    "GetValue": function() {
                        return Password();
                    }
                });

                _questions.push({
                    "QuestionID": 1001,
                    "DefaultValue": null,
                    "QuestionText": "Username",
                    "GetValue": function() {
                        return Username();
                    }
                });
            } else {
                _questions.push({
                    "QuestionID": 994,
                    "DefaultValue": null,
                    "QuestionText": "Username & Password",
                    "GetValue": function() {
                        return Username();
                    }
                });
            }
            _questions.push({
                "QuestionID": 995,
                "DefaultValue": null,
                "QuestionText": "Email&TC",
                "GetValue": function() {
                    return EmailAddress();
                }
            });


            if (options.insertGender === true) {
                var questionId;
                var questionText;
                var responses = [];
                var genderSeekEnabled = (typeof (PeopleMedia.CP.GenderSeekEnabled()) !== 'undefined' && PeopleMedia.CP.GenderSeekEnabled() !== null && PeopleMedia.CP.GenderSeekEnabled());
                if (genderSeekEnabled || options.combinedGender) {
                    questionId = 999;
                    questionText = "Gender&Seeking";
                    responses.push({ "ResponseID": 12, "ResponseText": "Man seeking women" });
                    responses.push({ "ResponseID": 21, "ResponseText": "Woman seeking men" });
                    if (genderSeekEnabled) {
                        responses.push({ "ResponseID": 11, "ResponseText": "Man seeking men" });
                        responses.push({ "ResponseID": 22, "ResponseText": "Woman seeking women" });
                    }
                } else {
                    questionId = 13;
                    questionText = "Gender";
                    responses.push({ "ResponseID": 1, "ResponseText": "Male" });
                    responses.push({ "ResponseID": 2, "ResponseText": "Female" });
                }
                _questions.splice(0,
                    0,
                    {
                        "QuestionID": questionId,
                        "QuestionText": questionText,
                        "DefaultValue": null,
                        "GetValue": function() {
                            if (HasGenderCombinedField()) {
                                return GenderCombined();
                            }
                            var result = ((Gender() || "") + "") + ((GenderSeek() || "") + "");
                            return (result.length === 2) ? result : "";
                        },
                        "Responses": responses
                    });
            }

            if (typeof options.questionDefaultValues !== 'undefined' && options.questionDefaultValues !== null) {
                var questionDefaultValuesIsArray = (Array.isArray) ? Array.isArray(options.questionDefaultValues) : Object.prototype.toString.call(options.questionDefaultValues) === '[object Array]';
                if (questionDefaultValuesIsArray) {
                    for (var questionIndex = 0; questionIndex < _questions.length; ++questionIndex) {
                        for (var defaultIndex = 0; defaultIndex < options.questionDefaultValues.length; ++defaultIndex) {
                            if (options.questionDefaultValues[defaultIndex].QuestionID === _questions[questionIndex].QuestionID) {
                                _questions[questionIndex].DefaultValue = options.questionDefaultValues[defaultIndex].DefaultValue;
                            }
                        }
                    }
                }
            }
            if (typeof options.questionOrder !== 'undefined' && options.questionOrder !== null) {
                var questionOrderIsArray = (Array.isArray) ? Array.isArray(options.questionOrder) : Object.prototype.toString.call(options.questionOrder) === '[object Array]';
                if (questionOrderIsArray) {
                    var tempQuestions = [];
                    for (var i = 0; i < options.questionOrder.length; i++) {
                        for (var j = 0; j < _questions.length; j++) {
                            if (options.questionOrder[i] === _questions[j].QuestionID) {
                                tempQuestions.push(_questions[j]);
                                break;
                            }
                        }
                    }
                    if (options.questionOrder.length === tempQuestions.length) {
                        _questions = tempQuestions;
                    }
                }
            }
            // PeopleMedia.CP.trackRegistrationEventLoadRegQuestions(_questions);
            //_panelCount = _questions.length;
            if (options.loadOnly !== true) {
                showPanel(1, "loadQuestions");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "loadQuestions" });
        }
    };

    var fireOnQuestionDisplay = function() {
        try {
            if (typeof (_onQuestionDisplay) !== 'undefined' && _onQuestionDisplay !== null) {
                _onQuestionDisplay();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "fireOnQuestionDisplay" });
        }
    };

    var showNextPanel = function() {
        try {
            if (_currentPanelNumber < _panelCount) {
                validateCurrentQuestion(function() {
                    ++_currentPanelNumber;
                    PeopleMedia.CP.Messaging.reset();
                    showPanel(_currentPanelNumber, "showNextPanel");
                });
            } else {
                validateCurrentQuestion(function() {
                    PeopleMedia.CP.Messaging.reset();
                    processRegistration();
                });
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showNextPanel" });
        }
    };

    var showPreviousPanel = function() {
        try {
            if (_currentPanelNumber > 1) {
                --_currentPanelNumber;
                PeopleMedia.CP.Messaging.reset();
                showPanel(_currentPanelNumber, "showPreviousPanel");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showPreviousPanel" });
        }
    };

    var showPanel = function(panelNum, source) {
        try {
            var currentPanelId = '#divRegistrationQuestions_' + panelNum.toString();
            var $currentPanel = $jq(currentPanelId);
            if ($currentPanel.length > 0) {
                hideAllPanels();
                $currentPanel.show();
                PeopleMedia.CP.trackRegistrationEventShow(currentPanelId, source);

                var displayedQuestions = PeopleMedia.CP.LoginRegistration.getDisplayedQuestionIds($currentPanel);
                if (displayedQuestions.length > 0) {
                    PeopleMedia.CP.trackRegistrationEventShowRegQuestions(displayedQuestions);
                }

                searchPositionLocators();
                fireOnQuestionDisplay();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showPanel" });
        }
    };

    var hideAllPanels = function() {
        try {
            for (var i = 1; i <= _panelCount; ++i) {
                if ($jq('#divRegistrationQuestions_' + i.toString()).length > 0) {
                    $jq('#divRegistrationQuestions_' + i.toString()).hide();
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "hideAllPanels" });
        }
    };

    var updateZipPostalCodeLabel = function() {
        try {
            var countrySelectName = CountryCodeFieldname();
            var zipCodeDisplay = 'none';
            var postalCodeDisplay = '';
            var countryCode = $jq('#' + countrySelectName).val();
            if (typeof (countryCode) !== 'undefined' && countryCode !== null && countryCode.toLowerCase() === 'us') {
                zipCodeDisplay = '';
                postalCodeDisplay = 'none';
            }
            $jq('.cssRegistrationZipCodeDisplay').each(function() {
                $jq(this).css('display', zipCodeDisplay);
            });
            $jq('.cssRegistrationPostalCodeDisplay').each(function() {
                $jq(this).css('display', postalCodeDisplay);
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "updateZipPostalCodeLabel" });
        }
    };

    var showZipPostalCodeCityState = function() {
        try {
            $jq('#' + PostalCodeDivFieldname()).fadeIn();
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showZipPostalCodeCityState" });
        }
    };

    var getCurrentQuestion = function() {
        try {
            if (_currentPanelNumber < 1 || _currentPanelNumber > Questions().length) {
                return null;
            }
            return Questions()[_currentPanelNumber - 1];
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getCurrentQuestion" });
        }
        return null;
    };

    var getCurrentQuestionID = function() {
        try {
            var question = getCurrentQuestion();
            if (typeof question !== 'undefined' && question !== null && typeof question.QuestionID !== 'undefined') {
                return question.QuestionID;
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getCurrentQuestionID" });
        }
        return null;
    };

    var getCurrentQuestionValue = function() {
        try {
            var question = getCurrentQuestion();
            if (typeof question !== 'undefined' &&
                question !== null &&
                question.GetValue &&
                Object.prototype.toString.call(question.GetValue) === '[object Function]') {
                return question.GetValue();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getCurrentQuestionValue" });
        }
        return null;
    };

    var validateCurrentQuestion = function(onValidationSuccess, onValidationFailure) {
        try {
            var panelIndex = _currentPanelNumber - 1;
            var currentQuestion = _questions[panelIndex];
            var errors = [];
            if (typeof (currentQuestion) !== 'undefined' && currentQuestion !== null) {
                switch (currentQuestion.QuestionID) {
                    case 991:   // Country
                        errors = validateCountryCode();
                        return validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);

                    case 992:  // Postal Code
                        validatePostalCode(function (errors) {
                            if (!errors || errors.length === 0) {
                                setBackgroundCheckDisclaimer(function () {
                                    validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);
                                });
                                return;
                            }
                            validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);
                        });
                        return;

                    case 993:  // Birthdate
                        errors = validateBirthDay();
                        return validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);

                    case 1000:  // Password
                        errors = validatePasswordFormat();
                        return validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);

                    case 1001:  // Username
                    case 994:   // Username & Password
                        errors = validateUsernameAndPassword();
                        return validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);

                    case 995:  // Email & TC
                        errors = validateEmailAddress().concat(validateEmailAddressConfirmation()
                            .concat(validateTermsAndConditions()));
                        return validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);

                    case 999:
                    case 13:
                        errors = validateGender();
                        return validateCurrentQuestionOnComplete(errors, onValidationSuccess, onValidationFailure);
                }
            }

            // no question to validate
            validateCurrentQuestionOnComplete([], onValidationSuccess, onValidationFailure);
           
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "validateCurrentQuestion" });
        }
    };

    var validateCurrentQuestionOnComplete = function (errors, onValidationSuccess, onValidationFailure) {
        if (typeof (errors) !== 'undefined' && errors !== null && errors.length > 0) {
            if (onValidationFailure) {
                onValidationFailure(errors);
            } else {
                PeopleMedia.CP.Messaging.show(errors);
            }
        } else {
            onValidationSuccess();
        }
    };

    var registerMarketingCapture = function(onSuccess, onFailure) {
        try {
            // var siteId = SiteId();
            var emailAddress = (EmailAddress() || "").trim();
            var countryCode = (CountryCode() || "").trim().toUpperCase();
            var postalCode = (PostalCode() || "").trim();
            var gender = Gender();
            var genderSeek = GenderSeek();
            var birthDate = BirthDate();

            if (HasGenderCombinedField()) {
                gender = GenderCombinedSelf();
                genderSeek = GenderCombinedSeeking();
            }

            PeopleMedia.CP.GenderID(gender);
            PeopleMedia.CP.GenderSeekID(genderSeek);

            var sourceId = parseInt(PeopleMedia.CP.SearchID(), 10);
            if (isNaN(sourceId) || sourceId <= 0) {
                sourceId = 999;
            }

            var url = "/v3/lps/api/RegisterMarketingCapture";
            var ajaxData = {
                "Gender": gender,
                "Birthdate": birthDate,
                "EmailAddress": emailAddress,
                "ZipCode": postalCode,
                "CountryCode": countryCode,
                "SourceId": sourceId,
                "AffiliateId": PeopleMedia.CP.AffiliateID(),
                "CaptureSource": "LandingPage_User"
            };

            var startTime = new Date().getTime();
            var timeoutValue = 30000;
            jQuery.ajax({
                headers: PeopleMedia.CP.LpsPostbackHeader(),
                type: "POST",
                url: url,
                data: JSON.stringify(ajaxData),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function(data) {
                    data.EmailAddress = emailAddress;
                    registerMarketingCaptureComplete(onSuccess, onFailure, data);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    var endTime = new Date().getTime();
                    var duration = (endTime - startTime);
                    var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                    if (!data.IsCancelled) {
                        PeopleMedia.CP.logAjax({ oid: Oid, method: "registerMarketingCapture", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                    }
                    registerMarketingCaptureComplete(onSuccess, onFailure, data);
                },
                async: true,
                cache: false,
                timeout: timeoutValue
            });

        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "registerMarketingCapture" });
            return;
        }
    };

    var registerMarketingCaptureComplete = function(onSuccess, onFailure, data) {
        try {
            var errors = [];
            var errObj;
            if (typeof (data) === "undefined" || data === null || data.IsValid !== true) {
                if (data && data.Fault && !data.Fault.IsCancelled) {
                    errors.push(PeopleMedia.CP.convertFaultToError(data.Fault));
                    try {
                        PeopleMedia.CP.trackMemberRegistrationEvent("RegisterMarketingCaptureFailure",
                            PeopleMedia.CP.formatRegistrationEventError(errors));
                    } catch (ex) {
                    }
                } else {
                    errObj = PeopleMedia.CP.createGeneralError((data && data.Message) ? data.Message : null);
                    errors.push(errObj);
                }
                if (typeof (onFailure) === "function") {
                    onFailure(errors);
                }
            } else {
                try {
                    PeopleMedia.CP.trackMemberRegistrationEvent("RegisterMarketingCaptureSuccess", data.EmailAddress);
                } catch (ex) {
                }
                if (typeof (onSuccess) === "function") {
                    onSuccess(data);
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "registerMarketingCaptureComplete" });
        }
    };

    var checkEmailAvailability = function(onSuccess, onFailure) {
        try {
            var errors = [];

            // var siteId = SiteId();
            var emailAddress = (EmailAddress() || "").trim();

            errors = errors.concat(validateEmailAddress());

            if (errors.length === 0 && emailAddress.length > 0) {
                PeopleMedia.CP.ui_busy();

                 var url = "/v3/lps/api/ValidateEmail";
                var ajaxData = {
                    "Email": emailAddress
                };

                var startTime = new Date().getTime();
                var timeoutValue = 15000;
                jQuery.ajax({
                    headers: PeopleMedia.CP.LpsPostbackHeader(),
                    type: "POST",
                    url: url,
                    data: JSON.stringify(ajaxData),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        checkEmailAvailability_complete(data, errors, onSuccess, onFailure);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        var endTime = new Date().getTime();
                        var duration = (endTime - startTime);
                        var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                        if (!data.IsCancelled) {
                            PeopleMedia.CP.logAjax({ oid: Oid, method: "checkEmailAvailability", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                        }
                        checkEmailAvailability_complete(data, errors, onSuccess, onFailure);
                    },
                    async: true,
                    cache: false,
                    timeout: timeoutValue
                });

            } else {
                if (onFailure) {
                    onFailure(errors);
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "checkEmailAvailability" });
            return;
        }
    };

    var checkEmailAvailability_complete = function(data, errors, onSuccess, onFailure) {
        try {
            errors = errors || [];
            PeopleMedia.CP.ui_done();

            if (errors.length > 0) {
                onFailure(errors, data);
            } else if (data && data.Fault && !data.Fault.IsCancelled) {
                errors.push(PeopleMedia.CP.convertFaultToError(data.Fault, "EmailAddress"));
                onFailure(errors, data);
            } else {
                if (typeof (data) === "undefined" || data === null || data.IsValid !== true) {
                    var registeredSiteId = (data) ? data.RegisteredSiteId : null;
                    if (registeredSiteId) {
                        errors.push({
                            Field: "EmailAddress",
                            Text: "The requested email address is already in use",
                            Code: "DuplicateEmailAddress"
                        });
                    } else {
                        errors.push({ Field: "EmailAddress", Text: "Invalid Email Address" });
                    }
                    onFailure(errors, data);
                } else {
                    onSuccess();
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "checkEmailAvailability_complete" });
        }
    };

    var locateMe = function (onSuccess, onFailure) {
        try {
            if (!!window.postMessage) {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        getLocationFromCoordinates(position.coords.latitude, position.coords.longitude, onSuccess, onFailure);
                    },
                    onFailure);
            }
        }
        catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "locateMe" });
        }
    };

    var searchPositionLocators = function() {
        try {
            var regMgrOptions = (typeof (regMgrOptions) === 'function') ? regMgrOptions() : {};

            $jq(".locate, .locate-hidden").each(function () {
                var $this = $jq(this);
                var target = $this.data().target;
                if (!regMgrOptions.customLocatorIcon) {
                    var $target = $jq(target);
                    var $firstTarget = $target.filter(":first");
                    $this.css("transform", "rotate(0deg)");
                    if ($target.length > 0) {
                        $this.height($firstTarget.outerHeight());
                        $this.width($this.height());
                        var newLeft = $target.offset().left + $target.outerWidth() - $this.outerWidth();
                        var newTop = $target.offset().top;
                        if (typeof (newLeft) !== "undefined" && typeof (newTop) !== "undefined") {
                            $this.offset({
                                left: newLeft,
                                top: newTop
                            });
                        }
                    } else {
                        $this.width($this.height());
                    }
                    $this.addClass("locate");
                    $this.removeClass("locate-hidden");
                }
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "searchPositionLocators" });
        }
    };

    var getLocationFromCoordinates = function(latitude, longitude, onSuccess, onFailure) {
        try {
            PeopleMedia.CP.ui_busy();

            var url = "/v3/lps/api/GetLocationByCoordinates";
            var ajaxData = {
                "Lat": latitude,
                "Long": longitude
            };

            var startTime = new Date().getTime();
            var timeoutValue = 15000;
            jQuery.ajax({
                headers: PeopleMedia.CP.LpsPostbackHeader(),
                type: "POST",
                url: url,
                data: JSON.stringify(ajaxData),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function(data) {
                    getLocationFromCoordinates_complete(data, onSuccess, onFailure);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    var endTime = new Date().getTime();
                    var duration = (endTime - startTime);
                    var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                    if (!data.IsCancelled) {
                        PeopleMedia.CP.logAjax({ oid: Oid, method: "getLocationFromCoordinates", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                    }
                    getLocationFromCoordinates_complete(data, onSuccess, onFailure);
                },
                async: true,
                cache: false,
                timeout: timeoutValue
            });

        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getLocationFromCoordinates" });
            return;
        }
    };

    var getLocationFromCoordinates_complete = function(data, onSuccess, onFailure) {
        try {
            var errors = [];
            PeopleMedia.CP.ui_done();
            if (data && data.Fault && !data.Fault.IsCancelled) {
                errors.push(PeopleMedia.CP.convertFaultToError(data.Fault, "Location"));
                onFailure(errors, data);
            } else if (!data || data.LocationFound !== true || !data.Location || !data.Location.ZipCode) {
                onFailure(errors, data);
            } else {
                // copy ZipCode to PostalCode for backwards compatibility
                data.PostalCode = data.Location.ZipCode;
                onSuccess(data);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getLocationFromCoordinates_complete" });
        }
    };

    var updateGreetings = function(apiContext, apiAuthToken, profileGreetings, onComplete) {
        try {
            var url = "/v3/lps/api/UpdateProfileComplete";
            var updateProfileCompleteRequest = {
                // "RegistrationStep": null,
                "Greetings": profileGreetings
            };

            var startTime = new Date().getTime();
            var timeoutValue = 60000;
            jQuery.ajax({
                type: "POST",
                url: url,
                data: JSON.stringify(updateProfileCompleteRequest),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function(updateProfileCompleteResponse) {
                    var detailResponse = $jq.extend({},
                        updateProfileCompleteResponse,
                        {
                            Context: apiContext || {},
                            Token: apiAuthToken || {}
                        });
                    onComplete(null, detailResponse);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    var endTime = new Date().getTime();
                    var duration = (endTime - startTime);
                    var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                    if (!data.IsCancelled) {
                        PeopleMedia.CP.logAjax({ oid: Oid, method: "updateGreetings", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                    }
                    onComplete(data, null);
                },
                async: true,
                cache: false,
                timeout: timeoutValue
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "updateGreetings" });
        }
    };

    // set Greeting1 from Facebook import
    // may not be correct for sites 27, 122 or 161 since Greeting1 isn't "A little about me"
    var setGreeting = function(apiContext, apiAuthToken, greeting, onComplete) {
        try {
            if (!greeting) {
                onComplete(null, null);
                return;
            }

            PeopleMedia.CP.ui_busy();

            // Performs
            var profileGreetings = [];
            profileGreetings.push({
                Id: 1,
                FreeTextResponse: (greeting || "").trim()
            });
            updateGreetings(apiContext,
                apiAuthToken,
                profileGreetings,
                function(updateGreetingsError, updateGreetingsResponse) {
                    PeopleMedia.CP.ui_done();

                    if (updateGreetingsError === null) {
                        PeopleMedia.CP.trackMemberRegistrationEvent("FacebookImportGreetingSuccessful", null);
                        onComplete(null, updateGreetingsResponse);
                    } else {
                        PeopleMedia.CP.FacebookImportGreetingFailed(true);
                        PeopleMedia.CP.trackMemberRegistrationEvent("FacebookImportGreetingFailed",
                            PeopleMedia.CP.formatRegistrationEventError(updateGreetingsError));
                        onComplete(updateGreetingsError, null);
                    }
                });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "setGreeting" });
        }
    };

    var importPhoto = function(photoUrl, onComplete) {
        try {
            if (!photoUrl) {
                onComplete({ errors: [] });
                return;
            }

            PeopleMedia.CP.ui_busy();
            var url = "/v3/media/GrabFacebookPhoto?photoUrl=" + encodeURIComponent(photoUrl);

            var startTime = new Date().getTime();
            var timeoutValue = 60000;
            jQuery.ajax({
                type: "GET",
                url: url,
                dataType: "json",
                success: function(data) {
                    importPhoto_complete(data, onComplete);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    var endTime = new Date().getTime();
                    var duration = (endTime - startTime);
                    var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                    if (!data.IsCancelled) {
                        PeopleMedia.CP.logAjax({ oid: Oid, method: "importPhoto", url: url, duration: duration, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                    }
                    importPhoto_complete(data, onComplete);
                },
                async: true,
                cache: false,
                timeout: timeoutValue
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "importPhoto" });
        }
    };

    var importPhoto_complete = function(data, onComplete) {
        try {
            var errors = [];
            PeopleMedia.CP.ui_done();
            if (data.Fault) {
                if (!data.Fault.IsCancelled) {
                    errors.push(PeopleMedia.CP.convertFaultToError(data.Fault, "ImportPhoto"));
                }
            } else if (data.status && data.status !== "Success") {
                errors.push({ Text: data.message });
            }
            var hasErrors = (errors.length > 0);
            PeopleMedia.CP.FacebookImportPhotoFailed(hasErrors);
            if (hasErrors) {
                PeopleMedia.CP.trackMemberRegistrationEvent("FacebookImportPhotoFailed",
                    PeopleMedia.CP.formatRegistrationEventError(errors));
            } else {
                PeopleMedia.CP.trackMemberRegistrationEvent("FacebookImportPhotoSuccessful", null);
            }
            onComplete({ errors: errors, data: data });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "importPhoto_complete" });
        }
    };

    return {
        OnRegistrationSuccess: OnRegistrationSuccess,
        OnRegistrationFailure: OnRegistrationFailure,
        RegistrationPanelId: RegistrationPanelId,
        RegistrationPanel: RegistrationPanel,
        UsernameFieldname: UsernameFieldname,
        Username: Username,
        PasswordFieldname: PasswordFieldname,
        Password: Password,
        EmailAddressFieldname: EmailAddressFieldname,
        EmailAddress: EmailAddress,
        CountryCodeFieldname: CountryCodeFieldname,
        PostalCodeFieldname: PostalCodeFieldname,
        PostalCode: PostalCode,
        GenderFieldname: GenderFieldname,
        Gender: Gender,
        GenderSeekFieldname: GenderSeekFieldname,
        GenderSeek: GenderSeek,
        GenderCombinedFieldname: GenderCombinedFieldname,
        HasGenderCombinedField: HasGenderCombinedField,
        GenderCombinedSelf: GenderCombinedSelf,
        GenderCombinedSeeking: GenderCombinedSeeking,
        BirthDateCombinedFieldname: BirthDateCombinedFieldname,
        HasBirthDateCombinedField: HasBirthDateCombinedField,
        BirthYearFieldname: BirthYearFieldname,
        RegistrationData: RegistrationData,
        Questions: Questions,
        PanelCount: PanelCount,
        CurrentPanelNumber: CurrentPanelNumber,
        OnQuestionDisplay: OnQuestionDisplay,
        initialize: initialize,
        processRegistration: processRegistration,
        validateUsername: validateUsername,
        validatePassword: validatePassword,
        validateUsernameAndPassword: validateUsernameAndPassword,
        validateUsernameFormat: validateUsernameFormat,
        validatePasswordFormat: validatePasswordFormat,
        validateUsernameFormatSimple: validateUsernameFormatSimple,
        validatePasswordFormatSimple: validatePasswordFormatSimple,
        validateEmailAddress: validateEmailAddress,
        validateEmailAddressFormat: validateEmailAddressFormat,
        validatePostalCode: validatePostalCode,
        validatePostalCodeFormat: validatePostalCodeFormat,
        validatePostalCodeFormatIsUsa: validatePostalCodeFormatIsUsa,
        validatePostalCodeFormatIsCanada: validatePostalCodeFormatIsCanada,
        validateGender: validateGender,
        validateBirthDay: validateBirthDay,
        validateBirthDayFormat: validateBirthDayFormat,
        standardOnRegistrationSuccess: standardOnRegistrationSuccess,
        standardOnRegistrationFailure: standardOnRegistrationFailure,
        loadQuestions: loadQuestions,
        showNextPanel: showNextPanel,
        showPreviousPanel: showPreviousPanel,
        showPanel: showPanel,
        hideAllPanels: hideAllPanels,
        updateZipPostalCodeLabel: updateZipPostalCodeLabel,
        showZipPostalCodeCityState: showZipPostalCodeCityState,
        getCurrentQuestion: getCurrentQuestion,
        getCurrentQuestionID: getCurrentQuestionID,
        getCurrentQuestionValue: getCurrentQuestionValue,
        validateCurrentQuestion: validateCurrentQuestion,
        registerMarketingCapture: registerMarketingCapture,
        checkEmailAvailability: checkEmailAvailability,
        locateMe: locateMe,
        searchPositionLocators: searchPositionLocators,
        setGreeting: setGreeting,
        importPhoto: importPhoto,
        setBackgroundCheckDisclaimer: setBackgroundCheckDisclaimer,
        getPostalCodeLocation: getPostalCodeLocation
    };

})(jQuery);

// for backwards compatibility only
PeopleMedia.CP.RegistrationManager = function () {
};

// for backwards compatibility only
PeopleMedia.CP.RegistrationManager.prototype = {
    OnRegistrationSuccess: PeopleMedia.CP.Registration.OnRegistrationSuccess,
    OnRegistrationFailure: PeopleMedia.CP.Registration.OnRegistrationFailure,
    RegistrationPanelId: PeopleMedia.CP.Registration.RegistrationPanelId,
    RegistrationPanel: PeopleMedia.CP.Registration.RegistrationPanel,
    UsernameFieldname: PeopleMedia.CP.Registration.UsernameFieldname,
    Username: PeopleMedia.CP.Registration.Username,
    PasswordFieldname: PeopleMedia.CP.Registration.PasswordFieldname,
    Password: PeopleMedia.CP.Registration.Password,
    EmailAddressFieldname: PeopleMedia.CP.Registration.EmailAddressFieldname,
    EmailAddress: PeopleMedia.CP.Registration.EmailAddress,
    CountryCodeFieldname: PeopleMedia.CP.Registration.CountryCodeFieldname,
    PostalCodeFieldname: PeopleMedia.CP.Registration.PostalCodeFieldname,
    PostalCode: PeopleMedia.CP.Registration.PostalCode,
    GenderFieldname: PeopleMedia.CP.Registration.GenderFieldname,
    Gender: PeopleMedia.CP.Registration.Gender,
    GenderSeekFieldname: PeopleMedia.CP.Registration.GenderSeekFieldname,
    GenderSeek: PeopleMedia.CP.Registration.GenderSeek,
    GenderCombinedFieldname: PeopleMedia.CP.Registration.GenderCombinedFieldname,
    HasGenderCombinedField: PeopleMedia.CP.Registration.HasGenderCombinedField,
    GenderCombinedSelf: PeopleMedia.CP.Registration.GenderCombinedSelf,
    GenderCombinedSeeking: PeopleMedia.CP.Registration.GenderCombinedSeeking,
    BirthDateCombinedFieldname: PeopleMedia.CP.Registration.BirthDateCombinedFieldname,
    HasBirthDateCombinedField: PeopleMedia.CP.Registration.HasBirthDateCombinedField,
    BirthYearFieldname: PeopleMedia.CP.Registration.BirthYearFieldname,
    RegistrationData: PeopleMedia.CP.Registration.RegistrationData,
    Questions: PeopleMedia.CP.Registration.Questions,
    PanelCount: PeopleMedia.CP.Registration.PanelCount,
    CurrentPanelNumber: PeopleMedia.CP.Registration.CurrentPanelNumber,
    OnQuestionDisplay: PeopleMedia.CP.Registration.OnQuestionDisplay,
    initialize: PeopleMedia.CP.Registration.initialize,
    processRegistration: PeopleMedia.CP.Registration.processRegistration,
    validateUsername: PeopleMedia.CP.Registration.validateUsername,
    validatePassword: PeopleMedia.CP.Registration.validatePassword,
    validateUsernameAndPassword: PeopleMedia.CP.Registration.validateUsernameAndPassword,
    validateUsernameFormat: PeopleMedia.CP.Registration.validateUsernameFormat,
    validatePasswordFormat: PeopleMedia.CP.Registration.validatePasswordFormat,
    validateUsernameFormatSimple: PeopleMedia.CP.Registration.validateUsernameFormatSimple,
    validatePasswordFormatSimple: PeopleMedia.CP.Registration.validatePasswordFormatSimple,
    validateEmailAddress: PeopleMedia.CP.Registration.validateEmailAddress,
    validateEmailAddressFormat: PeopleMedia.CP.Registration.validateEmailAddressFormat,
    validatePostalCode: PeopleMedia.CP.Registration.validatePostalCode,
    validatePostalCodeFormatIsUsa: PeopleMedia.CP.Registration.validatePostalCodeFormatIsUsa,
    validatePostalCodeFormatIsCanada: PeopleMedia.CP.Registration.validatePostalCodeFormatIsCanada,
    validateGender: PeopleMedia.CP.Registration.validateGender,
    validateBirthDay: PeopleMedia.CP.Registration.validateBirthDay,
    validateBirthDayFormat: PeopleMedia.CP.Registration.validateBirthDayFormat,
    standardOnRegistrationSuccess: PeopleMedia.CP.Registration.standardOnRegistrationSuccess,
    standardOnRegistrationFailure: PeopleMedia.CP.Registration.standardOnRegistrationFailure,
    loadQuestions: PeopleMedia.CP.Registration.loadQuestions,
    showNextPanel: PeopleMedia.CP.Registration.showNextPanel,
    showPreviousPanel: PeopleMedia.CP.Registration.showPreviousPanel,
    showPanel: PeopleMedia.CP.Registration.showPanel,
    hideAllPanels: PeopleMedia.CP.Registration.hideAllPanels,
    updateZipPostalCodeLabel: PeopleMedia.CP.Registration.updateZipPostalCodeLabel,
    showZipPostalCodeCityState: PeopleMedia.CP.Registration.showZipPostalCodeCityState,
    getCurrentQuestion: PeopleMedia.CP.Registration.getCurrentQuestion,
    getCurrentQuestionID: PeopleMedia.CP.Registration.getCurrentQuestionID,
    getCurrentQuestionValue: PeopleMedia.CP.Registration.getCurrentQuestionValue,
    validateCurrentQuestion: PeopleMedia.CP.Registration.validateCurrentQuestion,
    isUsernameTakenValidationError: PeopleMedia.CP.Registration.isUsernameTakenValidationError,
    registerMarketingCapture: PeopleMedia.CP.Registration.registerMarketingCapture,
    checkEmailAvailability: PeopleMedia.CP.Registration.checkEmailAvailability,
    locateMe: PeopleMedia.CP.Registration.locateMe,
    searchPositionLocators: PeopleMedia.CP.Registration.searchPositionLocators,
    setGreeting: PeopleMedia.CP.Registration.setGreeting,
    importPhoto: PeopleMedia.CP.Registration.importPhoto,
    setBackgroundCheckDisclaimer: PeopleMedia.CP.Registration.setBackgroundCheckDisclaimer,
    getPostalCodeLocation: PeopleMedia.CP.Registration.getPostalCodeLocation
};
